module.exports = __webpack_public_path__ + "static/img/style_2.d6ed8369.png";